import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TypeCounter from './TypeCounter';
var DefaultAssetCounts = function DefaultAssetCounts(_ref) {
  var assetCounts = _ref.assetCounts;
  var truck = assetCounts.truck,
    bus = assetCounts.bus,
    van = assetCounts.van,
    trailer = assetCounts.trailer,
    driver = assetCounts.driver;
  return /*#__PURE__*/React.createElement("div", {
    className: "display-flex"
  }, /*#__PURE__*/React.createElement(TypeCounter, {
    hideOnZero: true,
    icon: "truck-baseline",
    value: truck
  }), /*#__PURE__*/React.createElement(TypeCounter, {
    hideOnZero: true,
    icon: "trailer-baseline",
    value: trailer
  }), /*#__PURE__*/React.createElement(TypeCounter, {
    hideOnZero: true,
    icon: "bus-baseline",
    value: bus
  }), /*#__PURE__*/React.createElement(TypeCounter, {
    hideOnZero: true,
    icon: "van-baseline",
    value: van
  }), /*#__PURE__*/React.createElement(TypeCounter, {
    hideOnZero: true,
    icon: "driver",
    value: driver
  }));
};
var TreeSummary = /*#__PURE__*/React.memo(function (props) {
  var className = props.className,
    assetCounts = props.assetCounts,
    children = props.children;
  var classes = classNames('TreeSummary', 'display-flex', 'align-items-center', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, children || /*#__PURE__*/React.createElement(DefaultAssetCounts, {
    assetCounts: assetCounts
  }));
});
TreeSummary.displayName = 'TreeSummary';
TreeSummary.defaultProps = {
  assetCounts: {},
  className: ''
};
TreeSummary.propTypes = {
  assetCounts: PropTypes.shape({
    truck: PropTypes.number,
    trailer: PropTypes.number,
    bus: PropTypes.number,
    van: PropTypes.number,
    driver: PropTypes.number
  }),
  className: PropTypes.string
};
export default TreeSummary;